import { render, staticRenderFns } from "./customerCRM.vue?vue&type=template&id=76af328c&"
import script from "./customerCRM.vue?vue&type=script&lang=js&"
export * from "./customerCRM.vue?vue&type=script&lang=js&"
import style0 from "./customerCRM.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable,VDivider,VForm,VSimpleTable})
